import { RoundedSelect } from '@/components/RoundedSelect/RoundedSelect';
import { TextEditor } from '@/components/TextEditor/TextEditor';
import { Tooltip as TooltipComponent } from '@/components/Tooltip/Tooltip';
import { TooltipPropTypes } from '@/components/Tooltip/Tooltip.types';
import { FormContainer } from '@/domains/AuthModal/components';
import { TextInput } from '@/components/Forms/TextInput/TextInput';
import { FC } from 'react';
import { ISElectProps } from '@/components/RoundedSelect/Types';
import { styled } from '@mui/system';
import { Button } from '@/components/Button/Button';

export const ModalWrapper = styled(FormContainer)`
  gap: ${({ theme }) => theme.spacing(5)};
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  align-items: flex-start;
  min-width: 100vw;
  width: 100vw;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    gap: 0 ${({ theme }) => theme.spacing(5)};

    padding-top: ${({ theme }) => theme.spacing(14)};
    min-width: 640px;
    width: 640px;
    grid-template-columns: auto 1fr;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    min-width: 1024px;
    width: 1024px;
  }
`;

export const InputWrapper = styled('div')`
  position: relative;
  margin-top: ${({ theme }) => theme.spacing(-3)};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-column: 2/3;
    align-self: auto;
  }
`;
export const TitleInput = styled(TextInput)`
  margin-top: ${({ theme }) => theme.spacing(-4)};
  .MuiOutlinedInput-root:not(:focus-within) {
    border-color: transparent;
  }
`;

export const Select = styled(RoundedSelect as FC)<ISElectProps>`
  width: ${({ theme }) => theme.spacing(50)};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: ${({ theme }) => theme.spacing(74)};
  }
`;

export const Tooltip = styled(TooltipComponent as FC)<TooltipPropTypes>``;

export const PostError = styled('div')`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-column: 2/3;
  }
`;

export const Header = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-self: flex-start;
  gap: ${({ theme }) => theme.spacing(6)};
  align-items: center;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-wrap: nowrap;
    grid-column: 1/2;
    grid-row: 1/2;
    justify-content: space-between;
  }

  ${Tooltip} {
    display: block;
    ${({ theme }) => theme.breakpoints.up('sm')} {
      margin-right: auto;
      justify-self: flex-start;
      display: none;
    }
  }

  ${Select} {
    display: flex;
    ${({ theme }) => theme.breakpoints.up('sm')} {
      display: none;
    }
  }

  ${PostError} {
    display: flex;
    ${({ theme }) => theme.breakpoints.up('sm')} {
      display: none;
    }
  }
`;

export const Footer = styled('div')`
  display: flex;
  place-self: end;
  position: relative;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-top: ${({ theme }) => theme.spacing(6)};
    place-self: unset;
    grid-column: 2/3;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing(6)};
  }
  ${Tooltip} {
    display: none;
    ${({ theme }) => theme.breakpoints.up('sm')} {
      margin-right: auto;
      justify-self: flex-start;
      display: block;
    }
  }

  ${Select} {
    display: none;
    ${({ theme }) => theme.breakpoints.up('sm')} {
      display: flex;
    }
  }

  ${PostError} {
    display: none;
    ${({ theme }) => theme.breakpoints.up('sm')} {
      display: flex;
    }
  }
}
`;

export const Editor = styled(TextEditor)`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-column: 2/3;
  }
`;

export const PostButton = styled(Button)`
  margin-left: auto;
`;

export const CharCounter = styled('div')`
  position: absolute;
  right: ${({ theme }) => theme.spacing(4)};
  top: ${({ theme }) => theme.spacing(6.5)};
  color: ${({ theme }) => theme.palette.grey[300]};
`;
